const Footer = () => {
  return (
    <div className="nk-footer p-1">
      <div className="container-fluid">
        <div className="nk-footer-wrap justify-content-end">
          <div className="nk-footer-copyright">
            {/* &copy; طراحی و توسعه توسط{" "}
            <a
              href="https://hamzehazizzadeh.ir/"
              target="_blank"
              className="text-primary fw-bold"
              without
              rel="noreferrer"
            >
              حمزه عزیززاده
            </a> */}
            <a
              target="_blank"
              href="https://trustseal.enamad.ir/?id=547625&Code=CSAQT7Wx6MdDhC4kGTGZekYcPWlgtuG0"
            >
              <img
                referrerpolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=547625&Code=CSAQT7Wx6MdDhC4kGTGZekYcPWlgtuG0"
                alt=""
                className="cursor-pointer"
                width={40}
                code="CSAQT7Wx6MdDhC4kGTGZekYcPWlgtuG0"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
